import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Join from './pages/Join';
import Profile from './pages/Profile';
import Friends from './pages/Friends';
import Connections from './pages/Connections';
import Usage from './pages/Usage';
import Devices from './pages/Devices';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import EmailVerificationPending from './pages/EmailVerificationPending';
import GitHubCallback from './pages/GitHubCallback';
import GoogleCallback from './pages/GoogleCallback';
import AppleCallback from './pages/AppleCallback';
import DeviceLogin from './pages/DeviceLogin';
import DeviceAuthorized from './pages/DeviceAuthorized';
import Download from './pages/Download';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ErrorProvider>
          <ToastProvider>
            <WebSocketProvider>
              <Router>
                <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/download" element={<Download />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/email-verification-pending" element={<EmailVerificationPending />} />
              <Route path="/auth/github/callback" element={<GitHubCallback />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/auth/apple/callback" element={<AppleCallback />} />
              <Route path="/device-login" element={<DeviceLogin />} />
              <Route path="/device-authorized" element={<DeviceAuthorized />} />
              <Route path="/join/:shareCode" element={<Join />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/friends"
                element={
                  <ProtectedRoute>
                    <Friends />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/connections"
                element={
                  <ProtectedRoute>
                    <Connections />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/devices"
                element={
                  <ProtectedRoute>
                    <Devices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/usage"
                element={
                  <ProtectedRoute>
                    <Usage />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
                </div>
              </Router>
            </WebSocketProvider>
          </ToastProvider>
        </ErrorProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
